"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StrayDogs = function StrayDogs(props) {
	return _react2.default.createElement(
		_SvgIcon2.default,
		(0, _extends3.default)({ viewBox: "0 0 435.766 435.766", className: "custom-icon" }, props),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("circle", { cx: "332", cy: "85.883", r: "12" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M419.742,81.883c-18.531,0-34.438,1.304-49.801-14.059l-19.883-19.882c-9.004-9.002-21.21-14.059-33.942-14.059h-55.82 h-0.336c-12.754,0-24.984,5.054-34.019,14.058l-0.293,0.292l-37.453,37.452C180.386,93.493,176,104.084,176,115.127v12.57 c0,22.778,18.078,46.274,40.61,49.634c2.5,0.372,4.965,0.552,7.39,0.552v3.196c-39.43,22.724-120.332,68.548-136.351,84.447 C74.168,279.012,64,300.333,64,321.883c0,9.619,1.258,19.402,6.851,32.121L24,353.883c-13.254,0-24,10.746-24,24s10.746,24,24,24 h199.762c11.886,0,20.125-12.764,14.379-23.168c-5.117-9.262-13.203-16.65-22.973-20.89c5.496-10.916,8.687-19.95,22.473-19.95 H256v48.008c0,8.836,7.164,16,16,16h59.527c12.27,0,20.199-13.382,14.004-23.977c-7.375-12.619-20.398-21.532-35.606-23.426 l3.558-28.466c19.234-11.806,33.406-31.422,37.305-54.13c5.453-31.775-8.074-60.472-30.789-77.638v-32.364h48 c17.602,0,39.41-12.349,48.465-27.442c3.817-6.358,19.34-29.415,19.301-36.614C435.722,89.514,429.07,81.883,419.742,81.883z M223.93,161.712c-19.562,0-31.93-16.571-31.93-33.608v-12.973c0-6.651,2.539-13.164,7.508-18.131l37.453-37.451 c5.027-5.026,11.774-8.371,19.039-9.262v79.596C256,146.998,242.218,161.712,223.93,161.712z M24,385.883c-4.41,0-8-3.589-8-8 s3.59-8,7.957-8c57.942,0.15,43.574,0.112,56.554,0.146c5.926,7.782,6.89,9.098,15.965,15.854H24z M402.746,126.209 c-6.493,10.82-22.13,19.674-34.746,19.674h-40.809c-10.414,0-19.211-6.708-22.527-16H288c2.047,10.047,7.953,18.628,16,24.406 v47.921c23.047,17.422,36.117,37.266,31.019,66.968c-4.05,23.585-18.317,36.087-36.457,47.222 c-3.844,30.751-5.008,40.05-6.5,51.981c16.137,2.009,30.672,2.04,39.465,17.503c-33.457,0-26.145,0-59.527,0 c0-38.358,0-41.45,0-80h-16v15.992c-4.238,0-7.61,0-18.359,0c-4.938,0-9.543,1.31-13.91,3.155 c0.785-21.742-7.082-43.63-23.168-59.718l-11.313,11.313c23.722,23.734,22.27,58.453,8.75,79.633l-4.797,9.483 c12.446,5.397,24.375,8.767,30.558,20.142h-79.809c-35.45-0.032-63.446-28.586-63.867-63.138 c-0.34-19.142,8.344-38.943,25.922-52.037c17.61-13.117,114.966-69.42,133.993-80.384c0-4.351,0.008-11.243-0.012-15.378 c18.606-6.61,32.012-24.191,32.012-45.064v-80h44.121c8.488,0,16.625,3.371,22.625,9.372l19.879,19.881 C370.019,90.53,385,96.884,400.992,97.6c1.691,5.817,5.625,10.616,10.844,13.459L402.746,126.209z" })
			)
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
};

exports.default = StrayDogs;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/straydogs.js
// module id = 1833
// module chunks = 895